// styles.js
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const HEADER_HEIGHT = 30;
export const ROW_HEIGHT = 50;
export const ROWS_TO_SHOW = 3;
export const TOTAL_HEIGHT = HEADER_HEIGHT + ROW_HEIGHT * ROWS_TO_SHOW;

export const GridContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "customHeight" && prop !== "customHeaderHeight",
})(({ theme, customHeight, customHeaderHeight }) => {
  const headerHeight = customHeaderHeight || 35;
  return {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.grey[200]}`,
    height: customHeight || "100%", // permite override dinámico
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    "& .MuiDataGrid-root": {
      border: "none",
      backgroundColor: "transparent",
      flexGrow: 1,
      width: "100%",
      height: "100% !important",
      overflow: "hidden",
      "& .MuiDataGrid-main": {
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      },
      "& .MuiDataGrid-virtualScroller": {
        overflowX: "hidden !important",
        overflowY: "auto !important",
        position: "relative",
        margin: 0,
        "&::-webkit-scrollbar": {
          width: "8px",
          height: "0px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: theme.palette.grey[100],
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: theme.palette.grey[400],
          borderRadius: "4px",
          "&:hover": {
            backgroundColor: theme.palette.grey[600],
          },
        },
      },
      "& .MuiDataGrid-columnHeaders": {
        height: `${headerHeight}px !important`,
        minHeight: `${headerHeight}px !important`,
        maxHeight: `${headerHeight}px !important`,
        lineHeight: `${headerHeight}px !important`,
        backgroundColor: theme.palette.grey[100],
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        "& .MuiDataGrid-columnHeader": {
          height: `${headerHeight}px !important`,
          minHeight: `${headerHeight}px !important`,
          maxHeight: `${headerHeight}px !important`,
          lineHeight: `${headerHeight}px !important`,
          "&:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-columnHeaderTitleContainer": {
            padding: "0 16px",
            justifyContent: "flex-start",
          },
        },
      },
      "& .MuiDataGrid-virtualScrollerContent": {
        position: "relative",
        minHeight: "unset !important",
      },
      "& .MuiDataGrid-virtualScrollerRenderZone": {
        width: "100%",
        position: "relative",
      },
      "& .MuiDataGrid-row": {
        height: `${ROW_HEIGHT}px !important`,
        minHeight: `${ROW_HEIGHT}px !important`,
        maxHeight: `${ROW_HEIGHT}px !important`,
        margin: 0,
        borderBottom: `1px solid ${theme.palette.grey[100]}`,
        "&:hover": {
          backgroundColor: theme.palette.grey[50],
        },
        "&:last-child": {
          borderBottom: "none",
        },
      },
      "& .MuiDataGrid-cell": {
        height: `${ROW_HEIGHT}px !important`,
        minHeight: `${ROW_HEIGHT}px !important`,
        maxHeight: `${ROW_HEIGHT}px !important`,
        lineHeight: `${ROW_HEIGHT}px !important`,
        padding: "0 16px",
        border: "none",
        display: "flex",
        alignItems: "center",
        "&:focus": {
          outline: "none",
        },
        '&[data-field="monto"]': {
          justifyContent: "flex-end",
        },
        "& .MuiInputBase-root": {
          height: "40px",
        },
      },
    },
  };
});

export const useStyles = makeStyles((theme) => ({
  badge: {
    height: "auto",
    padding: "5px 12px",
  },
  toolbarContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
  },
  actionButtons: {
    display: "flex",
    gap: theme.spacing(1),
  },
  saveButton: {
    marginRight: theme.spacing(1),
  },
  headerCell: {
    backgroundColor: theme.palette.grey[100],
    fontWeight: "bold",
  },
  inputCell: {
    padding: 0,
  },
  totalSection: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
  },
  totalAmount: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
  disponiblePositive: {
    color: theme.palette.success.main,
  },
  disponibleNegative: {
    color: theme.palette.error.main,
  },
  datePicker: {
    width: "100%",
  },
}));

export const gridConfig = {
  HEADER_HEIGHT,
  ROW_HEIGHT,
  ROWS_TO_SHOW,
  TOTAL_HEIGHT,
};
